// Auto-generated by scripts/generate-hook-exports.cjs - DO NOT EDIT
import { setter } from "@/lib/contract-interactions/hooks";

export const {
  useAcceptOwnership,
  useBulkExitValidator,
  useBulkRegisterValidator,
  useBulkRemoveValidator,
  useCancelDeclaredOperatorFee,
  useClaimEthRewards,
  useCommitRoot,
  useDeclareOperatorFee,
  useDeposit,
  useExecuteOperatorFee,
  useExitValidator,
  useGetVersion,
  useInitialize,
  useLiquidate,
  useLiquidateSSV,
  useMigrateClusterToETH,
  useOnCSSVTransfer,
  useOwner,
  usePendingOwner,
  useProxiableUUID,
  useReactivate,
  useReduceOperatorFee,
  useRegisterOperator,
  useRegisterValidator,
  useRemoveOperator,
  useRemoveOperatorsWhitelistingContract,
  useRemoveOperatorsWhitelists,
  useRemoveValidator,
  useRenounceOwnership,
  useReplaceOracle,
  useRequestUnstake,
  useRescueERC20,
  useSetFeeRecipientAddress,
  useSetOperatorsPrivateUnchecked,
  useSetOperatorsPublicUnchecked,
  useSetOperatorsWhitelistingContract,
  useSetOperatorsWhitelists,
  useStake,
  useSyncFees,
  useTransferOwnership,
  useUpdateClusterBalance,
  useUpdateDeclareOperatorFeePeriod,
  useUpdateExecuteOperatorFeePeriod,
  useUpdateLiquidationThresholdPeriod,
  useUpdateLiquidationThresholdPeriodSSV,
  useUpdateMaximumOperatorFee,
  useUpdateMinBlocksBetweenUpdates,
  useUpdateMinimumLiquidationCollateral,
  useUpdateMinimumLiquidationCollateralSSV,
  useUpdateMinimumOperatorEthFee,
  useUpdateModule,
  useUpdateNetworkFee,
  useUpdateNetworkFeeSSV,
  useUpdateOperatorFeeIncreaseLimit,
  useUpdateQuorumBps,
  useUpdateUnstakeCooldownDuration,
  useUpgradeTo,
  useUpgradeToAndCall,
  useWithdraw,
  useWithdrawAllOperatorEarnings,
  useWithdrawAllOperatorEarningsSSV,
  useWithdrawAllVersionOperatorEarnings,
  useWithdrawNetworkSSVEarnings,
  useWithdrawOperatorEarnings,
  useWithdrawOperatorEarningsSSV,
  useWithdrawUnlocked,
} = setter;
